"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = void 0;
/**
 * A basic pub/sub event system
 * @class
 * @internal
 */
class Events {
    constructor() {
        /** Stores EventSubscribers for each event */
        this._subscribers = {};
    }
    /** Adds a subscription callback to an event */
    subscribe(eventName, subscriber) {
        const currentSubs = this._subscribers[eventName] || [];
        this._subscribers[eventName] = [...currentSubs, subscriber];
    }
    /** Removes a subscription callback from an event */
    unsubscribe(eventName, subscriber) {
        const currentSubs = this._subscribers[eventName] || [];
        this._subscribers[eventName] = currentSubs.filter((subscriber_) => subscriber_ !== subscriber);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (this._subscribers[eventName].length === 0) {
            delete this._subscribers[eventName];
        }
    }
    /** Pushes out a new event to all subscribed callbacks */
    publish(eventName, eventValue) {
        const currentSubs = this._subscribers[eventName] || [];
        currentSubs.forEach((subscriber) => subscriber(eventValue));
    }
}
exports.Events = Events;
